import React, { useState } from 'react';
import Select from 'react-select';
import { FlexRow } from 'components/styled-components';
import styled from 'styled-components';
import { TextArea, FormGroup } from '@blueprintjs/core';
import colors from 'utils/colors';
import find from 'lodash/find';
import { ErrorMessage } from 'formik';
import ErrorWrapper from 'components/forms/components/error-wrapper';
import { FastField } from 'formik';

const customStyles = {
  option: (base, { isSelected }) => {
    return isSelected
      ? { ...base, backgroundColor: colors.primary }
      : { ...base, color: '#31A1DA' };
  },
  control: base => ({
    // none of react-selects styles are passed to <Control />
    ...base,
    background: '#E8F0F7',
  }),
  dropdownIndicator: base => ({
    ...base,
  }),
};

const mapSelected = (selected, answers) => {
  if (selected.length >= 0) {
    const answer = find(answers, ['answerID', selected[0]]);
    return answer ? answer : null;
  } else {
    return selected;
  }
};

const QuestionField = props => {
  const [note, setNote] = useState(props.values[props.name].note);

  const handleNoteChange = e => {
    props.handleChange(e);
    setNote(e.target.value);
  };

  return (
    <Section id={props.name}>
      <Wrapper>
        <Heading>
          <StepIcon>{props.step}</StepIcon>
          <HeadingInformation>{props.question.question}</HeadingInformation>
        </Heading>
        <AnswerSection>
          <FlexRow justify="flex-start" margin="0.5rem auto">
            <FastField
              name={props.name}
              render={() => (
                <>
                  <FormGroup
                    label="Answer"
                    labelFor={`react-select-${props.question.questionNumber +
                      2}-input`}
                    style={{
                      maxWidth: '20rem',
                      width: '100%',
                    }}
                  >
                    <Select
                      options={props.answers.filter(
                        answer => answer.answer !== 'OPT_OUT'
                      )}
                      getOptionLabel={option => option.answer}
                      getOptionValue={option => option.answerID}
                      onChange={selected => {
                        props.setFieldValue(props.name, {
                          ...props.question,
                          selected,
                        });
                      }}
                      value={
                        props.values[props.name].selected.length >= 0
                          ? mapSelected(
                              props.values[props.name].selected,
                              props.question.answers
                            )
                          : props.values[props.name].selected
                      }
                      styles={customStyles}
                    />
                  </FormGroup>
                </>
              )}
            />
            <Notes>
              <FormGroup label="Notes" labelFor={`${props.name}[note]`}>
                <FastField
                  name={`${props.name}[note]`}
                  render={({ field }) => (
                    <TextArea
                      large
                      maxLength={500}
                      minLength={1}
                      value={note}
                      name={`${props.name}[note]`}
                      id={`${props.name}[note]`}
                      onChange={handleNoteChange}
                    />
                  )}
                />
              </FormGroup>
            </Notes>
          </FlexRow>
        </AnswerSection>
        <div style={{ marginTop: '-25px' }}>
          {' '}
          <ErrorMessage
            name={props.name}
            render={msg => <ErrorWrapper>{msg}</ErrorWrapper>}
          />
        </div>
      </Wrapper>
    </Section>
  );
};

const AnswerSection = styled.div``;
const Section = styled.div`
  width: 100%;
  border-top: 1px solid #e8e8e8;
  margin-bottom: 1rem;
`;
const Wrapper = styled.div`
  display: flex;
  padding: 2rem;
  flex-direction: column;
  width: 100%;
`;
const Heading = styled.div`
  display: flex;
  flex-wrap: nowrap;
  font-size: 18px;
  justify-content: center;
  align-items: baseline;
  color: ${colors.gray};
`;
const StepIcon = styled.div`
  border: 1px solid ${colors.brandingAccent};
  border-radius: 50%;
  min-width: 30px;
  height: 30px;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin-right: 1rem;
  color: ${colors.brandingPrimary};
`;
const HeadingInformation = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: space-between;
  letter-spacing: 1px;
  width: 100%;
`;

const Notes = styled.div`
  margin-left: 2rem;
`;

export default QuestionField;
